import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=60dc6baa&lang=pug&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60dc6baa')) {
      api.createRecord('60dc6baa', component.options)
    } else {
      api.reload('60dc6baa', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=60dc6baa&lang=pug&", function () {
      api.rerender('60dc6baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Projects.vue"
export default component.exports